import type React from "react";
import { useState } from "react";

type TProps = {
    setSelectedRows: React.Dispatch<React.SetStateAction<number[]>>;
    data: any;
    type?: string;
};

export function useSelectRows({ setSelectedRows, data, type }: TProps) {
    const [allSelected, setAllSelected] = useState(false);

    const handleSetAllSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setAllSelected(true);

            if (type === "payment") {
                setSelectedRows(
                    data.map((item) => {
                        if (item.paymentSliceId) {
                            return item.paymentSliceId;
                        } else {
                            return item.id;
                        }
                    }),
                );
            } else if (type === "advance") {
                setSelectedRows(data.map((item) => item.slice.id));
            } else {
                setSelectedRows(data.map((item) => item.id));
            }
        } else {
            setAllSelected(false);
            setSelectedRows([]);
        }
    };
    const handleSelectRow = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        if (e.target.checked) {
            setSelectedRows((prev) => [...prev, id]);
        } else {
            setSelectedRows((prev) => prev.filter((item) => id !== item));
        }
    };
    return { allSelected, setAllSelected, handleSetAllSelected, handleSelectRow };
}
